// src/contexts/merge-analytics-contexts/merge-analytics-contexts.ts
function mergeAnalyticsContexts(prevContext, values) {
  let newContext = structuredClone(prevContext);
  const { browser, device, geo, ...topLevelNonObjects } = values;
  newContext = {
    ...newContext,
    ...topLevelNonObjects
  };
  if (browser) {
    newContext.browser = {
      ...newContext.browser,
      ...browser
    };
  }
  if (device) {
    newContext.device = {
      ...newContext.device,
      // Casting is required because of how TS parses `device.type` with RecursivePartial. The types are identical.
      ...device
    };
  }
  if (geo) {
    newContext.geo = {
      ...newContext.geo,
      ...geo
    };
  }
  return newContext;
}

export {
  mergeAnalyticsContexts
};
